export const PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 50, 100, 500] as const;
export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number];
